import React, { useEffect } from "react";
import { useState } from "react";
import { motion } from "framer-motion";
import { blank_task, blank_task_eng } from "../utils/toasts";

const TaskInput = ({ todoState }) => {
  const today = new Date();
  const { todos, setTodos } = todoState;
  const [currentText, setcurrentText] = useState("");
  const [todolength, settodolength] = useState(todos.length);
  const addTodo = () => {
    if (currentText.length === 0 || currentText.trim().length === 0) {
      blank_task();
      blank_task_eng();
      return;
    }
    setTodos([
      ...todos,
      {
        id: todos.length + 1,
        task: currentText,
        date: today.toLocaleString("en-us", {
          day: "numeric",
          month: "short",
          year: "numeric",
        }),
        time: today.toLocaleString("en-us", {
          hour: "numeric",
          minute: "numeric",
        }),
      },
    ]);
    setcurrentText("");
  };
  useEffect(() => {
    if (todos.length > todolength)
      window.scrollTo({
        top: document.documentElement.scrollHeight,
        behavior: "auto",
      });
    settodolength(todos.length);
  }, [todos.length, todolength]);
  return (
    <div className="sticky top-[-20px] z-10 bg-taskinputbg flex flex-col items-center p-4">
      <h1 className="text-2xl p-2 m-2 font-bold font-Indie-Flower tracking-wider">
        Add Your Tasks here📝
      </h1>
      <textarea
        maxLength="150"
        placeholder="Add something..."
        value={currentText}
        onChange={(e) => {
          setcurrentText(e.target.value);
        }}
        className="min-h-[60px] max-h-[160px] p-2 border-2 border-black rounded-md w-[calc(60%_-_2rem)] md:w-[calc(50%_-_2rem)]"
      ></textarea>


      <motion.button
        whileHover={{
          scale: 1.2,
          transition: { duration: 0.1 },
        }}
        onClick={addTodo}
        className="bg-logo-color mr-[calc(30%_-_2rem)] font-semibold px-4 self-end font-Architects-Daughter py-1 mt-2 text-xl transition ease-in duration-200 uppercase rounded-full hover:bg-gray-800 hover:text-white drop-shadow-lg hover:border-gray-500  focus:outline-none"
      >
        ADD
      </motion.button>



      <motion.button
        whileHover={{
          scale: 1.5,
          transition: { duration: 0.5 },
        }}
        whileTap={{ scale: 0.9 }}
        className="pt-2 mr-2 self-end"
        onClick={() => {
          window.scrollTo({
            top: document.documentElement.scrollHeight,
            behavior: "smooth",
          });
        }}
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="28"
          height="28"
          fill="#0f172a"
          className="bi bi-arrow-down-circle-fill"
          viewBox="0 0 16 16"
        >
          <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zM8.5 4.5a.5.5 0 0 0-1 0v5.793L5.354 8.146a.5.5 0 1 0-.708.708l3 3a.5.5 0 0 0 .708 0l3-3a.5.5 0 0 0-.708-.708L8.5 10.293V4.5z" />
        </svg>
      </motion.button>
    </div>
  );
};

export default TaskInput;
